import { Button, SaveButton, Toolbar } from "react-admin";

interface IStyledToolbar {
  handleBack: () => void;
}

export const StyledToolbar: React.FC<IStyledToolbar> = ({ handleBack }) => (
  <Toolbar style={{ gap: 20, justifyContent: "space-between" }}>
    <SaveButton label="Сохранить" />
    <Button
      label="Назад"
      size="medium"
      onClick={handleBack}
      color="secondary"
      variant="outlined"
    />
  </Toolbar>
);
